import { useNavigate, useParams } from 'react-router-dom';
import { Container } from '@mui/material';
import { ExamFormValues, Loader, useCourse, usePartner } from '@shared';
import { RouteEnum } from 'App';
import { Form } from '../Form';
import { useUpdateExam } from './useUpdateExam';

type TypeProps = {
  partner: string;
  course: string;
  rootPath: RouteEnum;
};

export const Edit = ({ partner, course, rootPath }: TypeProps) => {
  const { id: exam } = useParams() as Record<string, string>;
  const { data, isLoading, updateExam, isUpdating } = useUpdateExam({
    partner,
    course,
    exam,
    rootPath,
  });
  const { safeBrowserEnabled } = usePartner({ partner });
  const courseName = useCourse({ partner, course });

  const navigate = useNavigate();
  const onExit = () => navigate(rootPath);
  const handleSubmit = (values: ExamFormValues) => {
    updateExam(values);
  };
  if (data) {
    return (
      <Container component='article' maxWidth='sm'>
        <Form
          courseName={courseName}
          onSubmit={handleSubmit}
          initialValues={data}
          isLoading={isUpdating || isLoading}
          onExit={onExit}
          title='Update Exam'
          submitButtonLabel='Save'
          safeBrowserEnabled={safeBrowserEnabled}
        />
      </Container>
    );
  } else {
    return <Loader />;
  }
};
